module.exports = __webpack_public_path__ + "img/i_ar_main_sec_w.6ce54daf.svg";